import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from  '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { CommonUtilService } from './common.service';
import * as moment from 'moment';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class SensorDataService {
	base_url = DDP_ENV.webdataUrl;
	_service = this;
	DATE_TIME_FORMAT = '';
	constructor(private _router: Router, private _http: Http, private cookieService: CookieService
		, private commonUtilService: CommonUtilService) {}

	/* Convert time stamp to epoch*/
	convertTimestamps(data) {
		if (!this.commonUtilService.isArray(data)) {
				data.timestamp = moment(data.timestamp).toDate().getTime();
			} else {
				data.forEach(function(value, index) {
					value.timestamp = moment(value.timestamp).toDate().getTime();
				});
			}
	}

	/* Get sensor data */
	getSensorData(dataStreamId, from , to): Observable<any> {
	    const url = this.base_url + '/sdata/conv?stream=' + dataStreamId + '&&from=' + moment(from).format('YYYYMMDDHHmmss')  + '&&to=' + moment(to).format('YYYYMMDDHHmmss');
		return this._http.get(url , this.buildHeaders())
		               .map((res: Response) => res.json());
	}

	/* Export sensor data */
	exportSensorData(dataStreamId, from , to): Observable<any> {
		return this._http.post(this.base_url + 'sdata/exp', this.buildHeadersForExportSensorData(dataStreamId, from , to))
    		.map((res: Response) => {
		        return res.json();
		    });
	}

	/* Export multiple signals */
	exportMultipleSignals(dataStreamIds, from , to, resampling, applyFilters, isZip) {
		applyFilters = (applyFilters === true) ? true : false;
		resampling = (resampling === true) ? true : false;
		const url = this.base_url  + '/sdata/exp/multiple' + (isZip ? '/zip' : '') + '?streams=' + dataStreamIds + '&&from=' + moment(from).format('YYYYMMDDHHmmss') + '&&to=' + moment(to).format('YYYYMMDDHHmmss')
		 + '&&resampling=' + resampling + '&&applyFilters=' + applyFilters;
		/*return this._http.post(url, '', this.buildHeadersForExportMultipleSignals(dataStreamIds, from ,to, resampling, applyFilters, isZip))
    		.map((res: Response) => {
		        return res.json()
		    });*/
		return this._http.post(url, '', this.buildHeadersForExportMultipleSignals(dataStreamIds, from , to, resampling, applyFilters, isZip))
			.map((res: Response) => {
				/*return res.json();*/
				let h = res.headers.get('content-disposition');
				this.downloadFile(res.arrayBuffer(), res.headers, isZip);
			});
	}

	/* Download a file */
	downloadFile(data, headers, isZip) {
		const file = new Blob([ data ], {
			type : headers.get('Content-Type') || (isZip ? 'application/zip;charset=utf-8' : 'text/csv;charset=utf-8')
		});
		const contentd = headers.get('Content-Disposition');
		let filename = headers.get('x-filename') || (isZip ? 'export-multiple.zip' : 'export-multiple.csv');
		if (contentd.indexOf('filename="') > 0) {
			filename = contentd.substr(contentd.indexOf('filename="') + 10);
			filename = filename.substr(0, filename.length - 1);
		}
		const fileURL = URL.createObjectURL(file);
		const a         = document.createElement('a');
		a.href        = fileURL;
		a.target      = '_blank';
		//a.visibility 	  = 'visibility:hidden';
		a.download    = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	getAvailability(userId, from, to): Observable<any> {
		return this._http.get(this.base_url + '/sdata/availability' , this.buildHeadersForAvailibility(userId, from , to))
		               .map((res: Response) => res.json());
	}

	getEvents(dataStreamId, from, to): Observable<any> {
		return this._http.get(this.base_url + '/analytics/events' , this.buildHeadersForSensorData(dataStreamId, from , to))
		               .map((res: Response) => res.json());
	}


	/************************* Build headers  **************************/

	private buildHeadersForSensorData(dataStreamId, from , to): any {
  		const params = new HttpParams()
			.set('stream', dataStreamId)
			.set('from', moment(from).format('YYYYMMDDHHmmss'))
			.set('to', moment(to).format('YYYYMMDDHHmmss'));
    	const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    	return new RequestOptions({ headers: headers, params: params });
  	}

  	private buildHeadersForExportSensorData(dataStreamId, from , to) {
  		const params = new HttpParams()
			.set('stream', dataStreamId)
			.set('from', moment(from).format('YYYYMMDDHHmmss'))
			.set('to', moment(to).format('YYYYMMDDHHmmss'));
    	const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token'),
    								'Content-type': 'text/csv;charset=utf-8',
    								'responseType': 'arraybuffer'});
    	return new RequestOptions({ headers: headers, params: params });
  	}

  	private buildHeadersForExportMultipleSignals(dataStreamIds, from , to, resampling, applyFilters, isZip) {
  		/*let params = new HttpParams()
			.set("streams", dataStreamIds)
			.set("from", moment(from).format("YYYYMMDDHHmmss"))
			.set("to", moment(to).format("YYYYMMDDHHmmss"))
			.set("resampling", resampling)
			.set("filter", applyFilters);*/
		const contentType = isZip ? 'application/zip;charset=utf-8' : 'text/csv;charset=utf-8';
		const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token'),
    								'Content-type': contentType,
    								'responseType': 'arraybuffer'});
    	return new RequestOptions({ headers: headers/*, params: params */});
  	}

  	private buildHeadersForAvailibility(userId, from , to): any {
  		const params = new HttpParams()
			.set('user', userId)
			.set('from', moment(from).format('YYYYMMDDHHmmss'))
			.set('to', moment(to).format('YYYYMMDDHHmmss'));
    	const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    	return new RequestOptions({ headers: headers, params: params });
  	}

	/* Construct a common header */
	private buildHeaders(): any {
		const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
		return new RequestOptions({ headers: headers });
	}

}
